import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './token.interceptor';
import { HttpUrlInterceptor } from './url.interceptor';

/**
 * Http interceptor providers in outside-in order.
 * TokenInterceptor must be registered only here (AppModule) — VDS-3328.
 */
export const HttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpUrlInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
];
